const PropTypes = require('prop-types');
const React = require('react');

const FlagHelper = require('utilities/flagHelper')

class Flag extends React.Component {
    render() {
        const { className, countryCode, pixelsSize } = this.props;
        const flagUrl = FlagHelper.getFlagUrl(countryCode, pixelsSize);
        return (
            <span>
                <img className={className} src={flagUrl} />
            </span>
        )
    }
}

Flag.propTypes = {
    className: PropTypes.string,
    countryCode: PropTypes.string.isRequired,
    pixelsSize: PropTypes.oneOf([16, 20])
};

Flag.defaultProps = {
    pixelsSize: 20
};

module.exports = Flag;
